var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0"},[_c(_setup.SettingsHeader),_vm._v(" "),_c(_setup.ProExpansionPanel),_vm._v(" "),_c(_setup.GeneralExpansionPanel),_vm._v(" "),_c(_setup.ExportExpansionPanel),_vm._v(" "),_c(_setup.ActionsExpansionPanel)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }